import React, { useState } from "react";
import "./Calculator.css";

function Calculator() {
  const [multiplier, setMultiplier] = useState("0.65");
  const [number, setNumber] = useState("");
  const [error, setError] = useState("");
  const [result, setResult] = useState({
    weekly: 0,
    monthly: 0,
    annual: 0,
  });

  const calculate = () => {
    const a = Number(number);
    const b = Number(multiplier);

    if (a <= 0 || isNaN(a)) {
      setError("Please, enter a valid mileage value.")
      setResult({
        weekly: 0,
        monthly: 0,
        annual: 0,
      });
      return;
    }

    setError("");


    const weekly = a * b;
    const monthly = weekly * 4; 
    const annual = weekly * 52;

    setResult({
      weekly: parseFloat(weekly.toFixed(2)),
      monthly: parseFloat(monthly.toFixed(2)),
      annual: parseFloat(annual.toFixed(2)),
    });
  };

  return (
    <div className="calc_container">
      <h2>
        Delivery <span>Calculator</span>
      </h2>
      <div className="calculator">
        <select
          className="type_driver"
          value={multiplier}
          onChange={(e) => setMultiplier(e.target.value)}
        >
          <option value="0.65">Solo</option>
          <option value="0.75">Team</option>
        </select>
        <select className="type_truck">
          <option value="0.6">VAN</option>
        </select>

        <input
          className="amount"
          type="number"
          value={number}
          onChange={(e) => setNumber(e.target.value)}
          placeholder="Enter weekly mileage"
        />

        <button className="calculated" onClick={calculate}>
          Calculate
        </button>
      </div>
      {error && <p className="error">{error}</p>}
      <div className={ !error ? "amount_totals" : "amount_totals_m"}>
        <div className="weekly card">
          <p>Weekly Net Income</p>
          <h3>${result.weekly}</h3>
        </div>
        <div className="monthly card">
          <p>Monthly Net Income</p>
          <h3>${result.monthly}</h3>
        </div>
        <div className="annual card">
          <p>Annual Net Income</p>
          <h3>${result.annual}</h3>
        </div>
      </div>
    </div>
  );
}

export default Calculator;
